/**
 * Labstep
 *
 * @module models/entity-state
 * @desc Typescript export class for EntityState
 */

import { Type } from 'class-transformer';
import { Entity } from 'labstep-web/models/entity.model';
import { EntityUser } from 'labstep-web/models/entity-user.model';
import { Group } from 'labstep-web/models/group.model';
import { User } from 'labstep-web/models/user.model';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';

export class EntityUserRole extends Entity {
  public static readonly entityName = 'entity_user_role' as const;

  public static readonly entityClass = 'entity_user_role' as const;

  public get entityName(): string {
    return EntityUserRole.entityName;
  }

  public constructor(data: Partial<EntityUserRole> = {}) {
    super();
    Object.assign(this, data);
  }

  public id!: string;

  public name!: string;

  public description!: string;

  public owner_id!: number;

  public author_id!: number;

  @Type(() => Group)
  public owner!: Group;

  @Type(() => User)
  public author!: User;

  @Type(() => EntityUser)
  public entity_users!: EntityUser[];

  static getHumanReadableEntityName(
    plural?: boolean,
    capitalized?: boolean,
  ): string {
    return getHumanReadableEntityName(
      this.entityName,
      plural,
      capitalized,
    );
  }
}
